module.exports = __webpack_public_path__ + "static/media/tired.02fe663a.svg";